import React from 'react';

import { Box, Text, VStack, theme } from '@squire/ui';

import { SearchIcon } from '@/components/_icons';
import { useScreenTranslations } from '@/hooks/useScreenTranslations';

import { styles } from './styles';
import type { EmptySearchStateProps } from './types';

// Copy for a list that came up empty before any term was entered. Once a term
// has been entered both variants share the "no results" copy.
const IDLE_COPY = {
  search: {
    title: 'startSearching',
    description: 'startSearchingDescription',
  },
  brandLocations: {
    title: 'noOtherLocations',
    description: 'noOtherLocationsDescription',
  },
} as const;

const SEARCHED_COPY = {
  title: 'noResults',
  description: 'noResultsDescription',
} as const;

const EmptySearchState: React.FC<EmptySearchStateProps> = ({
  hasSearched,
  variant = 'search',
}) => {
  const { t } = useScreenTranslations('HomeScreen');

  const { title, description } = hasSearched
    ? SEARCHED_COPY
    : IDLE_COPY[variant];

  return (
    <VStack
      centerHorizontal
      centerVertical
      padding={theme.spacing[6]}
      space={theme.spacing[4]}
    >
      <Box style={styles.icon}>
        <SearchIcon size={24} color="textSecondary" />
      </Box>

      <VStack centerVertical space={theme.spacing[3]}>
        <Text variant="xlStrong" color="textPrimary" align="center">
          {t(title) as string}
        </Text>
        <Text variant="m" color="textSecondary" align="center">
          {t(description) as string}
        </Text>
      </VStack>
    </VStack>
  );
};

EmptySearchState.displayName = 'EmptySearchState';
export { EmptySearchState };
